import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Tooltip, Typography } from '@mui/material';
import CommonNoDataFound from 'components/CommonNoDataFound/CommonNoDataFound';
import { truncateComment } from 'utils/utils';
import dummyImg from 'assets/images/SubVendorLogo.svg';
import mdStar from 'assets/images/mdStar.svg';

export default function FeedbackCard(props) {
  
  const navigate = useNavigate();
  const data = props?.dashboardFeedbackData?.data
  const onClickViewMore = () => {
    window.location.replace('/feedback')
  }

  const onFeedbackClick = (type, val) => {
    // TODO: Commenting this code for UAT deployment, for further we required this feature
    // if(type === 'driver'){
    //   navigate(`/driver/details`, {state: {driverId: val?.authId, name: val?.fullName, status: val?.DriverProfile?.status, id:val?.DriverProfile?.id, tabType:'dashboard'}})
    // }else{
    //   navigate(`/rideTrack/details`, {state: {id:val?.Trip?.id, tripId:val?.Trip?.tripId, status:val?.Trip?.status, customer:val?.fullName, tabType:'dashboard'}})
    //   window.location.reload()
    // }
  }

  const handleOnError = (e) => {
    e.target.src = dummyImg
  }

  return (
    <Grid container className='deliveryHeader colorLightBlue' p={0}>
      <Grid container className='tabMargin colorLightBlue'>
        <Grid item xs={6}>
          <Typography className='feedback'>
            Recent Feedback
          </Typography>
        </Grid>
      </Grid>
      {data?.length > 0 ?  (
        data?.map((val,id) => (<Grid item xs={12} key={val.id} className="rowStyle">
          <Grid container className='justifyBetween' alignItems="center">
            <Grid item xs ={2}>
              <img className='imgStyleAcceptence' src={val?.DriverProfile?.avtar && val?.DriverProfile?.avtar !== null ? val?.DriverProfile?.avtar : dummyImg} alt='img' onError={handleOnError}/>
            </Grid>
            <Grid item xs={8}>
              <Typography className='textStyle2'>
              <span onClick={() => onFeedbackClick('driver', val)}>{val?.fullName}</span>
                <span className='colorBlack'>{' Received '}</span><span className={(val.rating === 2 || val.rating === 1) ? 'colorRed' : 'colorYellow'}> {val?.tags?.length > 22 ? 
                <Tooltip title={val?.tags} placement="bottom">
                  {truncateComment(val?.tags, 22)}
                </Tooltip>
                : val?.tags }</span><span className='colorBlack'> {" feedback for"} </span> 
                <span  onClick={() => onFeedbackClick('rideTrack', val)}> {"Trip ID "+ val?.Trip?.tripId} </span>
              </Typography>
            </Grid>
            <Grid item xs={2} className='justifyCenter'>
            <img src={mdStar} alt='styleimg'/><span className='ml5'>{val.rating}</span>
            </Grid>
          </Grid>
        </Grid>))):
        
         <Grid item sm={12}> <CommonNoDataFound/> </Grid>
        
      }
      {/* TODO: Commenting this code for UAT deployment, for further we required this feature */}
      {/* {data?.length > 3 && <Grid className='justifyEnd padding15 width100 mt25'>
        <Typography onClick={() => onClickViewMore()} className='viewStyle cursor'>
          View more
        </Typography>
      </Grid>} */}
    </Grid>
  );
}